import { getInventoryMaximum } from '../../helpers/inventoryMaximum';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Pencil } from 'react-bootstrap-icons';

export const priceText = value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0
  ? Number(value).toLocaleString('en-US', {style:'currency',currency:'USD'}) : '';

export default function InventoryPriceReference({value,unit,onEdit,disabled=false}) {
  const reference = unit ? getInventoryMaximum(unit) : {value};
  const amount=priceText(reference.value);
  return <span className="inventory-price-reference">
    <span title={reference.reason}>{amount || '—'}</span>
    {onEdit && <Button size="sm" variant="link" className="p-1 d-print-none" aria-label="Edit maximum sales price in calculation worksheet" title="Open calculation worksheet" disabled={disabled} onClick={onEdit}>
      {!amount && <span>Calculate </span>}<Pencil size={12}/>
    </Button>}
  </span>;
}
